import RecoverStep from "../recover_step";
import axios from "../../../../axios-instance";

const TEMPLATE = 'in-progress';

export default class RbRecoveryInProgress extends RecoverStep {

  constructor() {
    super(TEMPLATE);
  }

  open(data, el, fr, previousStep) {
    this.startExport(data, el, fr);
  }

  startExport(data, el, fr) {
    data.render = {loading: true};
    fr.render('recoveryInProgress');
    const format = data.recovery.virtualization.format || '';
    const conversion_type = data.recovery.virtualization.type || '';
    let uri = `/ftps_export/start/${data.recovery.machineId}/${data.recovery.restorePoint}/${data.recovery.type}/${format}`
    if (format !== '' && conversion_type !== '') {
      uri += `/${conversion_type}`
    }
    axios.post(uri).then(
      response => {
        data.recovery.export_uuid = response.data.export_uuid;
        const checkStatus = () => {
          axios.get(`/ftps_export/get_status/${data.recovery.export_uuid}`).then(response => {
            if (response.data.status === 'COMPLETED') {
              data.render.loading = false;
              fr.goTo('exportComplete');
            } else if (response.data.status === 'ERROR') {
              data.render.loading = false;
              data.render.showRPInUseError = response.data.rpInUseError;
              data.render.showError = !data.render.showRPInUseError;
              data.render.isRecoverError = response.data.isRecoverError;
              data.render.error = true;
              fr.render();
            } else {
              setTimeout(checkStatus, 5000);
            }
          }).catch((error) => {
            this.handleRecoveryError(data, el, fr);
          });
        }
        setTimeout(checkStatus, 5000);
      }
    ).catch((error) => {
      this.handleRecoveryError(data, el, fr);
    });
  }

  retryExport(data, el, fr) {
    data.render = {loading: true};
    fr.render('recoveryInProgress');
    if (data.recovery.export_uuid) {
      const checkStatus = () => {
        axios.get(`/ftps_export/get_status/${data.recovery.export_uuid}`).then(response => {
          if (response.data.status === 'COMPLETED') {
            data.render.loading = false;
            fr.goTo('exportComplete');
          } else if (response.data.status === 'ERROR') {
            this.startExport(data, el, fr);
          } else {
            setTimeout(checkStatus, 5000);
          }
        }).catch((error) => {
          this.handleRecoveryError(data, el, fr);
        });
      }
      setTimeout(checkStatus, 5000);
    } else {
      this.startExport(data, el, fr);
    }
  }

  handleRecoveryError(data, el, fr) {
    data.render.loading = false;
    data.render.showRPInUseError = false;
    data.render.isRecoverError = true;
    data.render.showError = true;
    data.render.error = true;
    fr.render();
  }

  transitionBack(data, el, fr) {
    data.recovery.openRpCalendarAfterReloadData = true
    fr.goTo('selectRestorePoint');
  }

  transitionTryAgain(data, el, fr) {
    this.retryExport(data, el, fr);
  }
}
